import axios from "axios"
import { IKiz2DocumentGetDTO } from "../../coreapi-dto/dirs/kiz";
import { IActRevaluationGetDTO } from "../../coreapi-dto/documents/ActRevaluation";
import { IActRevaluationItemEditDTO, IActRevaluationItemGetDTO } from "../../coreapi-dto/documents/ActRevaluationItem";
import { envF } from "../../../env";

export const getActRevaluationItemUpdateDTO = async (idDocument: string, callback: (revaluationEditItems: IActRevaluationItemEditDTO[]) => void, errCallback?: () => void) => {

    const jwtToken = localStorage.getItem("TokenData") as string;
    const token = `Bearer ${JSON.parse(jwtToken).accessToken}`;
    const header = {
        headers: {
            Authorization: token
        },
    }

    const generateKizRequestUrl = (idDocumentItem) => {
        return `${envF.REACT_APP_API_GATEWAY_PATH}/Kiz/Document/${idDocument}/Item/${idDocumentItem}`
    }

    const generateActRevaluationRequestUrl = () => {
        return `${envF.REACT_APP_API_GATEWAY_PATH}/ActRevaluation/${idDocument}`
    }

    let actRevaluation = await axios.get<IActRevaluationGetDTO>(
        generateActRevaluationRequestUrl(),
        header
    )

    let items: IActRevaluationItemEditDTO[] = []

    const itemsPush = async (x: IActRevaluationItemGetDTO) => {
        if (!x.isKiz) {
            items.push({
                idGlobal: x.idGlobal as string,
                idActRevaluationGlobal: x.idActRevaluationGlobal,
                idLotGlobal: x.lot.idGlobal,
                retailAdpriceOld: x.retailAdpriceOld,
                retailPriceIncVatOld: x.retailPriceIncVatOld,
                retailCostInfo: x.retailCostInfo,
                supplierCostInfo: x.supplierCostInfo,
                producerPrice: x.producerPrice,
                isKiz: x.isKiz,
                lotName: x.lot.displayName,
                quantity: x.quantity,
                goodsCode: x.goodsCode,
                producer: x.producer,
                isGnvls: x.isGnvls,
                idGoodsGlobal: x.goods.idGlobal,
                idScalingRatioGlobal: x.scalingRatio.idGlobal,
                comment: '',
                dateCreated: x.dateCreated,
                isOsu: x.kizOsuDto?.barcode !== undefined,
                kizOsuDto: x.kizOsuDto,
                actualPrice: x.actualPrice,
                gtin: x.gtin,
                isPieceAccountingKizOsu: x.isPieceAccountingKizOsu
            })
        } else {
            await axios.get<IKiz2DocumentGetDTO>(
                generateKizRequestUrl(x.idGlobal),
                header
            ).then((e) => {
                items.push({
                    idGlobal: x.idGlobal as string,
                    idActRevaluationGlobal: x.idActRevaluationGlobal,
                    idLotGlobal: x.lot.idGlobal,
                    retailCostInfo: x.retailCostInfo,
                    supplierCostInfo: x.supplierCostInfo,
                    producerPrice: x.producerPrice,
                    isKiz: x.isKiz,
                    isGnvls: x.isGnvls,
                    lotName: x.lot.displayName,
                    goodsCode: x.goodsCode,
                    retailAdpriceOld: x.retailAdpriceOld,
                    retailPriceIncVatOld: x.retailPriceIncVatOld,
                    producer: x.producer,
                    quantity: x.quantity,
                    kizs: e.data.items[0].kizes ?? [],
                    kizBoxes: e.data.items[0].kizBoxes ?? [],
                    kizOsuDtos: e.data.items[0].kizOsuDtos ?? [],
                    idGoodsGlobal: x.goods.idGlobal,
                    idScalingRatioGlobal: x.scalingRatio.idGlobal,
                    comment: '',
                    dateCreated: x.dateCreated,
                    isOsu: x.kizOsuDto?.barcode !== undefined,
                    kizOsuDto: x.kizOsuDto,
                    actualPrice: x.actualPrice,
                    gtin: x.gtin,
                    isPieceAccountingKizOsu: x.isPieceAccountingKizOsu
                })
            }).catch(() => {
                items.push({
                    idGlobal: x.idGlobal as string,
                    idActRevaluationGlobal: x.idActRevaluationGlobal,
                    idLotGlobal: x.lot.idGlobal,
                    retailCostInfo: x.retailCostInfo,
                    supplierCostInfo: x.supplierCostInfo,
                    producerPrice: x.producerPrice,
                    retailAdpriceOld: x.retailAdpriceOld,
                    retailPriceIncVatOld: x.retailPriceIncVatOld,
                    isKiz: x.isKiz,
                    isGnvls: x.isGnvls,
                    lotName: x.lot.displayName,
                    quantity: x.quantity,
                    goodsCode: x.goodsCode,
                    producer: x.producer,
                    kizs: [],
                    kizBoxes: [],
                    kizOsuDtos: [],
                    idGoodsGlobal: x.goods.idGlobal,
                    idScalingRatioGlobal: x.scalingRatio.idGlobal,
                    comment: '',
                    dateCreated: x.dateCreated,
                    isOsu: x.kizOsuDto?.barcode !== undefined,
                    kizOsuDto: x.kizOsuDto,
                    actualPrice: x.actualPrice,
                    gtin: x.gtin,
                    isPieceAccountingKizOsu: x.isPieceAccountingKizOsu
                })
                errCallback?.()
            })
        }
    }

    const addItems = async () => {

        const unresolvedPromises = actRevaluation.data.items.map((x) => itemsPush(x));
        const results = await Promise.all(unresolvedPromises);
    }

    addItems().then(() => callback(items))

}


